import { formatMoney, RoundingStrategy } from "@faire/web--source/common/money";
export var getOrderMinimum = function(isFirstOrder, minimumOrderAmount, strictLocalize) {
    if (minimumOrderAmount === undefined) {
        return "";
    }
    var minimunOrderAmountMoney = formatMoney({
        money: minimumOrderAmount,
        roundingStrategy: RoundingStrategy.DROP_CENTS_ROUND_UP
    });
    if (isFirstOrder) {
        return strictLocalize({
            id: "LcZ6Eq",
            defaultMessage: [
                {
                    type: 1,
                    value: "minimunOrderAmountMoney"
                },
                {
                    type: 0,
                    value: " min"
                }
            ]
        }, {
            minimunOrderAmountMoney: minimunOrderAmountMoney
        });
    }
    return strictLocalize({
        id: "TTxO/q",
        defaultMessage: [
            {
                type: 1,
                value: "minimunOrderAmountMoney"
            },
            {
                type: 0,
                value: " reorder"
            }
        ]
    }, {
        minimunOrderAmountMoney: minimunOrderAmountMoney
    });
};
